"use strict";
import decode_auth_token from '../decodeAuthToken';
import _ from 'lodash';

const validatePermissions = (modulePermissions = null, campaign_id = null) => {
    try {
        if (modulePermissions.length > 0) {
            const user = decode_auth_token();
            if (user.campaigns) {
                let campaign = {};
                if (Array.isArray(campaign_id)) {
                    campaign['id'] = [];
                    campaign['permissions'] = [];
                    let auxCampaigns = user.campaigns.filter(c => campaign_id.includes(c.id));
                    for (let cp of auxCampaigns) {
                        campaign.id.push(cp.id);
                        campaign.permissions = _.union(campaign.permissions, cp.permissions);
                    }
                } else {
                    campaign = campaign_id !== null ? user.campaigns.filter(c => c.id === campaign_id)[0] : null;
                }
                if (campaign && campaign.permissions) {
                    for (let permission of modulePermissions) {
                        if (campaign.permissions.includes(permission.toLowerCase().trim())) {
                            return {isValid: true};
                        }
                    }
                    return {isValid: false, name: 'InvalidAccess', message: `Invalid Access`};
                } else {
                    return {isValid: false, name: 'InvalidPermisison', message: `Invalid permisisons`};
                }
            } else {
                return {isValid: false, name: 'InvalidCampaign', message: 'Campaign not found'};
            }
        } else {
            throw "Empty array permissions";
        }
    } catch (err) {
        console.log('RMS', err);
        return {isValid: false, error: err};
    }
}

export default validatePermissions;
